import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "margin": "1rem 0.6rem",
    "border": "1px solid #999",
    "border-radius": "1rem"
  }
};
const _hoisted_2 = {
  style: {
    "margin": "1rem 0.6rem",
    "border": "1px solid #999",
    "border-radius": "1rem"
  }
};
const _hoisted_3 = {
  style: {
    "margin": "1rem 0.6rem",
    "border": "1px solid #999",
    "border-radius": "1rem"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  return _openBlock(), _createElementBlock("div", {
    class: "",
    id: "selfme",
    style: _normalizeStyle([{
      'minHeight': $data.viewhight + 'px'
    }, {
      "background-color": "aliceblue",
      "border": "1px solid #1989FA"
    }])
  }, [_createVNode(_component_van_nav_bar, {
    title: "尧都区殡仪馆",
    style: {
      "background-color": "lightblue"
    }
  }), _createElementVNode("div", {
    style: _normalizeStyle([{
      'height': $data.viewhight - 60 + 'px'
    }, {
      "overflow-y": "scroll"
    }])
  }, [_createElementVNode("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("img", {
    src: "/img/t2.jpg",
    width: "100%",
    height: "150",
    alt: ""
  }, null, -1)), _createElementVNode("div", {
    style: {
      "padding": "0.7rem 0.8rem",
      "background-color": "#fff",
      "font-size": "0.96rem"
    },
    onClick: _cache[0] || (_cache[0] = (...args) => $options.tofee && $options.tofee(...args))
  }, "尧都区殡仪馆收费公式表")]), _createElementVNode("div", _hoisted_2, [_cache[4] || (_cache[4] = _createElementVNode("img", {
    src: "/img/t3.jpg",
    width: "100%",
    height: "150",
    alt: ""
  }, null, -1)), _createElementVNode("div", {
    style: {
      "padding": "0.7rem 0.8rem",
      "background-color": "#fff",
      "font-size": "0.96rem"
    },
    onClick: _cache[1] || (_cache[1] = $event => $options.toprovince())
  }, "山西省殡仪服务站管理实施办法")]), _createElementVNode("div", _hoisted_3, [_cache[5] || (_cache[5] = _createElementVNode("img", {
    src: "/img/t4.jpg",
    width: "100%",
    height: "150",
    alt: ""
  }, null, -1)), _createElementVNode("div", {
    style: {
      "padding": "0.7rem 0.8rem",
      "background-color": "#fff",
      "font-size": "0.96rem"
    },
    onClick: _cache[2] || (_cache[2] = $event => $options.topublic())
  }, "中华人民共和国《殡葬管理条例》")]), _cache[6] || (_cache[6] = _createStaticVNode("<div style=\"margin:1rem 0.6rem;border:1px solid #999;border-radius:1rem;\"><img src=\"/img/t2.jpg\" width=\"100%\" height=\"150\" alt=\"\"><div style=\"padding:0.7rem 0.8rem;background-color:#fff;font-size:0.96rem;\">尧都区殡仪馆收费公式表</div></div><div style=\"margin:1rem 0.6rem;border:1px solid #999;border-radius:1rem;\"><img src=\"/img/t3.jpg\" width=\"100%\" height=\"150\" alt=\"\"><div style=\"padding:0.7rem 0.8rem;background-color:#fff;font-size:0.96rem;\">山西省殡仪服务站管理实施办法</div></div><div style=\"margin:1rem 0.6rem;border:1px solid #999;border-radius:1rem;\"><img src=\"/img/t4.jpg\" width=\"100%\" height=\"150\" alt=\"\"><div style=\"padding:0.7rem 0.8rem;background-color:#fff;font-size:0.96rem;\">中华人民共和国《殡葬管理条例》</div></div><div style=\"margin:1rem 0.6rem;border:1px solid #999;border-radius:1rem;\"><img src=\"/img/t2.jpg\" width=\"100%\" height=\"150\" alt=\"\"><div style=\"padding:0.7rem 0.8rem;background-color:#fff;font-size:0.96rem;\">尧都区殡仪馆收费公式表</div></div><div style=\"margin:1rem 0.6rem;border:1px solid #999;border-radius:1rem;\"><img src=\"/img/t3.jpg\" width=\"100%\" height=\"150\" alt=\"\"><div style=\"padding:0.7rem 0.8rem;background-color:#fff;font-size:0.96rem;\">山西省殡仪服务站管理实施办法</div></div><div style=\"margin:1rem 0.6rem;border:1px solid #999;border-radius:1rem;\"><img src=\"/img/t4.jpg\" width=\"100%\" height=\"150\" alt=\"\"><div style=\"padding:0.7rem 0.8rem;background-color:#fff;font-size:0.96rem;\">中华人民共和国《殡葬管理条例》</div></div>", 6))], 4)], 4);
}